<template>
  <div id="app">
    <vue-headful
      title="奔驰铸星培训"
      description="奔驰铸星培训"
      :head="{
        'meta[charset]': { charset: 'utf-8' },
        'meta[viewport]': { width: 'device-width', 'initial-scale': '1.0' },
      }"
    />
    <router-view />
  </div>
</template>

<script>
import Vue from "vue";
import vueHeadful from "vue-headful";
import { getProjectInfo, getArticles } from './shared/api';
import { isLocalhost } from './shared/utils';
import {qtInit} from './lib/qtLIb';
import VConsole from 'vconsole';
if (process.env.VUE_APP_DEBUG === 'true') {
  new VConsole();
  console.log('ready vConsole!');
}

Vue.component("vue-headful", vueHeadful);

const dpr = window.devicePixelRatio || 1;
document.documentElement.setAttribute("data-dpr", dpr);
// target as iphone 6 or x
document.documentElement.style.fontSize =
  (document.documentElement.offsetWidth / 375) * 11 + "px";
console.log('fontSize: ', document.documentElement.style.fontSize);

export default {
  name: "app",
  methods: {
    doWeixin() {
      if (!isLocalhost) {
        if (this.isWeixin) {
          console.log("APP is in Weixin");
        } else {
          document.head.innerHTML =
            '<title>抱歉，出错了</title><meta charset="utf-8"><meta name="viewport" content="width=device-width, initial-scale=1, user-scalable=0"><link rel="stylesheet" type="text/css" href="https://res.wx.qq.com/open/libs/weui/0.4.1/weui.css">';
          document.body.innerHTML =
            '<div class="weui_msg"><div class="weui_icon_area"><i class="weui_icon_info weui_icon_msg"></i></div><div class="weui_text_area"><h4 class="weui_msg_title">请在微信客户端打开链接</h4></div></div>';
        }
      }
    },
    //禁止安卓手机修改字体
    changeFont() {
      if (
        typeof window.WeixinJSBridge == "object" &&
        typeof window.WeixinJSBridge.invoke == "function"
      ) {
        this.handleFontSize();
      } else {
        if (document.addEventListener) {
          document.addEventListener(
            "WeixinJSBridgeReady",
            this.handleFontSize,
            false
          );
        } else if (document.attachEvent) {
          document.attachEvent("WeixinJSBridgeReady", this.handleFontSize);
          document.attachEvent("onWeixinJSBridgeReady", this.handleFontSize);
        }
      }
    },
    handleFontSize() {
      // 设置网页字体为默认大小
      window.WeixinJSBridge.invoke("setFontSizeCallback", { fontSize: 0 });
      // 重写设置网页字体大小的事件
      window.WeixinJSBridge.on("menu:setfont", function () {
        window.WeixinJSBridge.invoke("setFontSizeCallback", { fontSize: 0 });
      });
    },
    onBridgeReady() {
      //
    },
    hideToolbar() {
      document.addEventListener(
        "WeixinJSBridgeReady",
        function onBridgeReady() {
          //
        }
      );
    },
  },
  created() {
    this.$store.commit('setEnterUrl', location.href);
    qtInit()
    getProjectInfo().then(res => {
      this.$store.commit('setAppInfo', res);
      res.catalogs.forEach((tab, index) => {
        tab.catalogs.filter(module => module.name === 'banner').forEach(banner => {
          getArticles(banner.id).then(articles => {
            this.$store.commit('setBannerArticales', { index, articles:articles.data });
          });
        });
      });
    }).catch(err => {
      console.error(err);
    });
  },
  mounted() {
    this.changeFont();
  },
};
</script>

<style lang="scss">
body {
  margin: 0;
}
#app {
  font-family: Arial, "PingFangSCRegular";
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  //background-color: rgb(237,237,237);
  background-color: #e5e5e5;
}

#nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>
